import { render, staticRenderFns } from "./confirm-password.vue?vue&type=template&id=30e273c7&"
import script from "./confirm-password.vue?vue&type=script&lang=ts&"
export * from "./confirm-password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports